const ProgressBar = () => null;

export default ProgressBar;
